import * as Yup from 'yup';
import { Locale } from '@synergy/models';
import { fields } from '@synergy/utils';

import { ImportIntervalType } from '../../models/import-supplier';
import { ImportSupplierFormikValues } from '../../models/import-supplier-formik-values';

const fieldNames = fields<ImportSupplierFormikValues>();

export const importSupplierAddValidationSchema = (locale: Locale) =>
    Yup.object().shape({
        [fieldNames.supplier]: Yup.object().typeError('app.error.required').required('app.error.required'),
        [fieldNames.importIntervalType]: Yup.string().nullable(),
        [fieldNames.importReceptionType]: Yup.string().nullable(),

        [fieldNames.time]: Yup.date()
            .nullable()
            .when(fieldNames.importIntervalType, {
                is: ImportIntervalType.Daily,
                then: schema => schema.typeError('app.error.required').required('app.error.required'),
                otherwise: schema => schema.notRequired(),
            }),

        [fieldNames.weekday]: Yup.number()
            .nullable()
            .when(fieldNames.importIntervalType, {
                is: ImportIntervalType.Weekly || ImportIntervalType.EveryTwoWeeks || ImportIntervalType.Yearly,
                then: schema => schema.typeError('app.error.required').required('app.error.required'),
                otherwise: schema => schema.notRequired(),
            }),

        [fieldNames.dayOfMonth]: Yup.number()
            .nullable()
            .when(fieldNames.importIntervalType, {
                is: ImportIntervalType.Monthly,
                then: schema => schema.typeError('app.error.required').required('app.error.required'),
                otherwise: schema => schema.notRequired(),
            }),

        [fieldNames.month]: Yup.number()
            .nullable()
            .when(fieldNames.importIntervalType, {
                is: ImportIntervalType.Yearly,
                then: schema => schema.typeError('app.error.required').required('app.error.required'),
                otherwise: schema => schema.notRequired(),
            }),
    });
